/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Mou } from './mou';
import { Program } from './program';
import { AgencyState } from './agency-state';
import { UserAccount } from './user-account';
import { AgencyStatus } from './agency-status';
import { Moa } from './moa';


export interface Agency { 
    accountDenialReason?: string;
    addressConfidential?: boolean;
    addressMailingCity?: string;
    addressMailingSameAsPhysical?: boolean;
    addressMailingStateLookup?: string;
    addressMailingStreet?: string;
    addressMailingZip?: string;
    addressPhysicalCity?: string;
    addressPhysicalStateLookup?: string;
    addressPhysicalStreet?: string;
    addressPhysicalZip?: string;
    adminEmail?: string;
    adminFirstName?: string;
    adminLastName?: string;
    adminPhone?: string;
    agencyDescription?: string;
    agencyEin?: string;
    agencyEmail?: string;
    agencyName?: string;
    agencyPhone?: string;
    agencyState?: AgencyState;
    agencyStatus?: AgencyStatus;
    agencyStatusDate?: string;
    agencyType?: Agency.AgencyTypeEnum;
    agencyWebsite?: string;
    appointmentDurationInHours?: number;
    createdDate?: string;
    expiresDate?: string;
    id?: string;
    isTestAgency?: boolean;
    moa?: Moa;
    moaAgreement?: boolean;
    mou?: Mou;
    olderThanYear: boolean;
    primaryContactEmail?: string;
    primaryContactFirstName?: string;
    primaryContactLastName?: string;
    primaryContactPhone?: string;
    probationProgramProvider?: boolean;
    programs?: Set<Program>;
    proposedInsuranceExpirationDate?: string;
    resubmissionReason?: string;
    serviceFamilyMember?: boolean;
    serviceProbationer?: boolean;
    serviceVictim?: boolean;
    userAccounts?: Array<UserAccount>;
    version: number;
}
export namespace Agency {
    export const AgencyTypeEnum = {
        Private: 'PRIVATE',
        Public: 'PUBLIC'
    } as const;
    export type AgencyTypeEnum = typeof AgencyTypeEnum[keyof typeof AgencyTypeEnum];
}


